const GridIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.18 7.50016H10.4867C9.14667 7.50016 8.5 6.90683 8.5 5.68016V2.6535C8.5 1.42683 9.15333 0.833496 10.4867 0.833496H13.18C14.52 0.833496 15.1667 1.42683 15.1667 2.6535V5.6735C15.1667 6.90683 14.5133 7.50016 13.18 7.50016ZM10.4867 1.8335C9.59333 1.8335 9.5 2.08683 9.5 2.6535V5.6735C9.5 6.24683 9.59333 6.4935 10.4867 6.4935H13.18C14.0733 6.4935 14.1667 6.24016 14.1667 5.6735V2.6535C14.1667 2.08016 14.0733 1.8335 13.18 1.8335H10.4867Z"
        fill="CurrentColor"
      />
      <path
        d="M13.18 15.1667H10.4867C9.14667 15.1667 8.5 14.5133 8.5 13.18V10.4867C8.5 9.14667 9.15333 8.5 10.4867 8.5H13.18C14.52 8.5 15.1667 9.15333 15.1667 10.4867V13.18C15.1667 14.5133 14.5133 15.1667 13.18 15.1667ZM10.4867 9.5C9.7 9.5 9.5 9.7 9.5 10.4867V13.18C9.5 13.9667 9.7 14.1667 10.4867 14.1667H13.18C13.9667 14.1667 14.1667 13.9667 14.1667 13.18V10.4867C14.1667 9.7 13.9667 9.5 13.18 9.5H10.4867Z"
        fill="CurrentColor"
      />
      <path
        d="M5.5135 7.50016H2.82016C1.48016 7.50016 0.833496 6.90683 0.833496 5.68016V2.6535C0.833496 1.42683 1.48683 0.833496 2.82016 0.833496H5.5135C6.8535 0.833496 7.50016 1.42683 7.50016 2.6535V5.6735C7.50016 6.90683 6.84683 7.50016 5.5135 7.50016ZM2.82016 1.8335C1.92683 1.8335 1.8335 2.08683 1.8335 2.6535V5.6735C1.8335 6.24683 1.92683 6.4935 2.82016 6.4935H5.5135C6.40683 6.4935 6.50016 6.24016 6.50016 5.6735V2.6535C6.50016 2.08016 6.40683 1.8335 5.5135 1.8335H2.82016Z"
        fill="CurrentColor"
      />
      <path
        d="M5.5135 15.1667H2.82016C1.48016 15.1667 0.833496 14.5133 0.833496 13.18V10.4867C0.833496 9.14667 1.48683 8.5 2.82016 8.5H5.5135C6.8535 8.5 7.50016 9.15333 7.50016 10.4867V13.18C7.50016 14.5133 6.84683 15.1667 5.5135 15.1667ZM2.82016 9.5C2.0335 9.5 1.8335 9.7 1.8335 10.4867V13.18C1.8335 13.9667 2.0335 14.1667 2.82016 14.1667H5.5135C6.30016 14.1667 6.50016 13.9667 6.50016 13.18V10.4867C6.50016 9.7 6.30016 9.5 5.5135 9.5H2.82016Z"
        fill="CurrentColor"
      />
    </svg>
  );
};

export { GridIcon };
export default GridIcon;
